/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_ListFCDOPostsRow } from '../models/db_ListFCDOPostsRow';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class FcdoPosts {
    /**
     * Get a list of fcdo posts
     * @param isoCountryCode2 Country code
     * @param userId User ID
     * @returns db_ListFCDOPostsRow OK
     * @throws ApiError
     */
    public static listFcdoPosts(
        isoCountryCode2?: string,
        userId?: number,
    ): CancelablePromise<Array<db_ListFCDOPostsRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/fcdo-posts',
            query: {
                'iso_country_code_2': isoCountryCode2,
                'user_id': userId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
